
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import toast from "@/functions/toast.function";
import { checkURL, convertDate } from "@/functions/userinterface.function";
import { RULE_FILE_SIZE_MAXIMUMLENGTH } from "@/constants/rule.constant";

import FileDragInput from "@/components/input/FileDragInput.vue";

@Component({
  filters,
  components: {
    FileDragInput,
  },
})
export default class ModalNewBroadcast extends Vue {
  /* VUEX */

  /* ACTIONS */
  @Action("actionGetCandidates", { namespace: "messaging" })
  private actionGetCandidates: any;
  @Action("actionCreateBroadcast", { namespace: "messaging" })
  private actionCreateBroadcast: any;

  /* STATE */
  @State("locale")
  private locale: string;
  @State("school", { namespace: "academy" })
  private school: any;
  @State("array_candidates", { namespace: "messaging" })
  private array_candidates: Array<any>;

  /* PROP */
  @Prop({ default: false })
  private isShow: boolean;

  private data = {
    link: '',
    chat: '',
    image: null,
    type: 0,
    year: null,
    student_id: new Array<number>(),
  };
  private type_options = [
    {
      id: 1,
      name: 'All students',
      translation: 'Semua siswa',
    },
    {
      id: 2,
      name: 'Choose by graduation year',
      translation: 'Pilih berdasarkan tahun kelulusan',
    },
    // {
    //   id: 3,
    //   name: 'Select student',
    //   name_translation: 'Pilih siswa',
    // },
  ];
  private candidateValue = "";
  private array_year: Array<number> = [];

  private get countStudent() {
    return this.data.student_id.length;
  }

  private created() {
    const yearNow = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      this.array_year.push(yearNow - i);
    }
  }

  /* METHOD */
  private clickClose() {
    this.data = {
      link: '',
      chat: '',
      image: null,
      type: 0,
      year: null,
      student_id: new Array<number>(),
    };
    this.$emit("update:isShow", false);
  }

  private clickSubmit() {
    // if (!this.data.image) {
    //   toast.warning(this.$t('warning_image'));
    //   return;
    // }

    if ((this.data.image as unknown as File)) {
      if ((this.data.image as unknown as File).size  > RULE_FILE_SIZE_MAXIMUMLENGTH) {
        toast.warning(this.$t('warning_image_maximum'));
        return;
      }
    }

    // if (!this.data.link) {
    //   toast.warning(this.$t('warning_link'));
    //   return;
    // }

    if (this.data.link && !checkURL(this.data.link)) {
      toast.warning(this.$t('warning_invalid_link'));
      return;
    }

    if (!this.data.chat) {
      toast.warning(this.$t('warning_chat'));
      return;
    }

    const newDate = new Date();
    const send_time = convertDate(newDate, "YYYY-MM-DD hh:mm:ss");

    this.actionCreateBroadcast({
      params: {
        ...this.data,
        send_time,
        school_id: this.school.id,
      },
      success: (data: any) => {
        this.$emit("success", data);
        this.clickClose();
      },
    })
  }

  private selectedItem(item: any) {
    let itemId = item.id;
    return this.data.student_id.includes(itemId);
  }

  private clickItem(item: any) {
    let index = this.data.student_id.indexOf(item.id);
    if (index < 0) {
      this.data.student_id.push(item.id);
    } else {
      this.data.student_id.splice(index, 1);
    }
    this.candidateValue = "";
  }

  private searchCandidates(event: any) {
    const { value } = event.target;
    if (value) {
      this.actionGetCandidates({
        params: {
          school_id: this.school.id,
          search: value,
          loader: false,
        },
      });
    } else {
      this.actionGetCandidates({
        params: {
          school_id: this.school.id,
          loader: false,
        }
      });
    }
  }
}
